import React from 'react'
import Page from '../../../layout/Page'
import { Modal, Button, DropdownItemProps, Segment, Header, Grid, Form, Label } from 'semantic-ui-react'
import Result from '../../../../common/repository/Result'
import { toast } from '../../../common/Toast'
import Table from '../../../app/Table'
import RequirePermission from '../../../base/RequirePermission'
import permissions from '../../../../common/permissions'
import Filters from './Filters'
import FilterPageContext from './FilterPageContext'
import LodgingExpensesForm from "./LodgingExpensesForm"
import config from '../../../../common/repository/config'
import LodgingExpensesRepository, { GetLodgingExpensesObject } from '../../../../common/repository/LodgingExpensesRepository'
import LodgingExpenses from '../../../../models/LodgingExpenses'
import LodgingExpensesColumnRenderer from "./LodgingExpensesColumnRenderer"
import moment from 'moment'
import FileLabel from '../../../common/FileLabel'

const statusData = ["Accepted", "Rejected"];
const statusDatas = statusData.map((it) => {
    return { text: it, value: it, key: it };
});

interface State {
    loading: boolean
    filter: string
    limit: number
    offset: number
    totalCount: number
    lodgingExpenses: LodgingExpenses[]
    update_modalOpen: boolean
    update_model: LodgingExpenses | null
    lodging_amount: string;
    receipt_modalOpen: boolean
    receipt_model: LodgingExpenses | null

    remove_modalOpen: boolean
    remove_model: LodgingExpenses | null
    loadingEssentialData: boolean
    startDateFilter: string
    endDateFilter: string
    requestStatusFilter: string
    receiptStatusFilter: string
    requestStatusOptions: DropdownItemProps[]
    receiptStatusOptions: DropdownItemProps[]
}
interface Props {
    ismodel: LodgingExpenses;
}

class LodgingExpensesPage extends React.Component<Props, State> {

    private LodgingExpensesRepository = new LodgingExpensesRepository()

    private columnRenderer = new LodgingExpensesColumnRenderer(
        (model: LodgingExpenses) => {
            return (
                <Button
                    size="mini"
                    primary
                    onClick={() =>
                        this.setState({
                            receipt_modalOpen: true,
                            receipt_model: model,
                            lodging_amount: model.getLodgingAmount() || ""
                        })
                    }
                >
                    Open
                </Button>
            )
        },
        (obj: any) => true
    )

    constructor(props: any) {
        super(props)

        this.state = {
            loading: false,
            limit: 10,
            offset: 0,
            filter: '',
            totalCount: 0,
            lodgingExpenses: [],
            update_modalOpen: false,
            update_model: null,
            lodging_amount: "",
            remove_modalOpen: false,
            remove_model: null,
            receipt_modalOpen: false,
            receipt_model: null,
            loadingEssentialData: true,
            requestStatusFilter: '',
            receiptStatusFilter: "",
            receiptStatusOptions: statusDatas,
            requestStatusOptions: statusDatas,
            startDateFilter: "",
            endDateFilter: "",
        }
    }

    async componentDidMount() {
        this.loadData()
        // await this.effectLoadEssentialData()
    }
    private onRowsPerPageChange = (page: number, rowsPerPage: number) => {
        // console.log('onRowsPerPageChange', page, rowsPerPage)
        const offset = (page - 1) * rowsPerPage,
            limit = offset + rowsPerPage
        this.setState({ offset, limit }, this.loadData)
    }

    private setFilter = (filter: string) => {
        this.setState({ filter, offset: 0 }, this.loadData)
    }

    private clearAllFilters = async () => {
        await this.setState({
            limit: 0,
            offset: 0,
            receiptStatusFilter: "",
            requestStatusFilter: "",
            startDateFilter: "",
            endDateFilter: ""
        })
        await this.loadData()
    }

    private getLodgingExpenses = async () => {
        const ro: GetLodgingExpensesObject = {
            limit: this.state.limit,
            offset: this.state.offset,
            search: this.state.filter,
        }

        if (this.state.requestStatusFilter) ro.request_status = this.state.requestStatusFilter
        if (this.state.startDateFilter) ro.start_date = this.state.startDateFilter;
        if (this.state.endDateFilter) ro.end_date = this.state.endDateFilter;
        if (this.state.receiptStatusFilter) ro.lodging_receipts_status = this.state.receiptStatusFilter

        return await this.LodgingExpensesRepository.getLodgingExpenses(ro)
    }

    private loadData = async () => {
        if (this.state.receiptStatusFilter || this.state.requestStatusFilter || this.state.startDateFilter || this.state.endDateFilter) {
            await this.setState({ offset: 0 })
        }
        let offset = this.state.offset

        this.setState({ loading: true }, async () => {
            const result = await this.getLodgingExpenses()
            if (result instanceof Result.Success) {
                if (offset === 0) {
                    //if offset 0 initialize as new list
                    const lodgingExpenses = result.data.items
                    const totalCount = result.data.totalItemCount
                    await this.setState({
                        loading: false,
                        offset: lodgingExpenses.length,
                        lodgingExpenses,
                        totalCount: totalCount,
                    })
                } else {
                    //else check for duplicate items in the new data
                    // and then concat with the old
                    const lodgingExpenses = [...this.state.lodgingExpenses, ...result.data.items]
                    const offset = lodgingExpenses.length
                    this.setState({ loading: false, offset, lodgingExpenses })
                }
            } else {
                const message = result.message || 'Something went wrong'
                await this.setState({ loading: false }, () => toast.error(message))
            }
        })
    }
    
    private actionReceipt  = async (status: string) => {
        if (!this.state.receipt_model) return;
        let ro = {
            expenseId: this.state.receipt_model.getId(),
            receiptStatus: status,
            investigatorId: this.state.receipt_model.getInvestigatorId()._id
        }
        console.log(ro, "requestObj");
        const result = await this.LodgingExpensesRepository.actionLodgingReceipt(ro);
        if (result instanceof Result.Success) {
            toast.success(result.message || `Receipt ${status.toLowerCase()} successfully`);
            this.setState({
                receipt_modalOpen: false,
                receipt_model: null,
                offset: 0
            });

            this.loadData();
        } else {
            toast.error(result.message || "Something went wrong")
        }
    } 

    private actionAmount  = async () => {
        if (!this.state.receipt_model) return;
        let ro = {
            expenseId: this.state.receipt_model.getId(),
            expenseAmount: this.state.lodging_amount,
            investigatorId: this.state.receipt_model.getInvestigatorId()._id
        }

        const result = await this.LodgingExpensesRepository.actionLodgingAmount(ro);
        if (result instanceof Result.Success) {
            toast.success(result.message);
            this.setState({
                receipt_modalOpen: false,
                receipt_model: null,
                offset: 0
            });

            this.loadData();
        } else {
            toast.error(result.message || "Something went wrong")
        }
    }

    render() {
        return (
            <FilterPageContext.Provider
                value={{
                    options: {
                       requestStatusData: this.state.requestStatusOptions,
                       receiptStatusData: this.state.receiptStatusOptions
                    },
                    filters: {
                        requestStatus: this.state.requestStatusFilter,
                        receiptStatus: this.state.receiptStatusFilter,
                        startDate: this.state.startDateFilter,
                        endDate: this.state.endDateFilter,
                        setRequestStatus: (status: string) => {
                            this.setState({ requestStatusFilter: status });
                        },

                        setReceiptStatus: (status: string) => {
                            this.setState({ receiptStatusFilter: status });
                        },
                        setStartDate: (date: string) => {
                            this.setState({ startDateFilter: date });
                        },

                        setEndDate: (date: string) => {
                            this.setState({ endDateFilter: date });
                        },

                        applyFilters: this.loadData,
                        clearAllFilters: this.clearAllFilters,
                    },
                }}
            >
                <Page title="Lodging Expenses" description="Manage Lodging Expenses">

                    <Segment>
                        <Filters />
                    </Segment>
                    <Table
                        renderer={this.columnRenderer}
                        data={this.state.lodgingExpenses}
                        totalDataCount={this.state.totalCount}
                        loading={this.state.loading}
                        load={this.loadData}
                        onRowsPerPageChange={this.onRowsPerPageChange}
                        onSearch={this.setFilter}
                        onClear={() => this.setFilter('')}
                    />
                    <Modal
                        open={this.state.receipt_modalOpen}
                        onClose={() =>
                            this.setState({
                                receipt_modalOpen: false,
                                receipt_model: null
                            })
                        }
                        size="large"
                    >
                        <Modal.Header>
                            Lodging Expense Details
                        </Modal.Header>

                        <Modal.Content scrolling>
                            {this.state.receipt_model && (
                                <div>

                                    {/* REQUEST INFORMATION */}

                                    <Segment>
                                        <Header size="small" color="blue">
                                            Request Information
                                        </Header>

                                        <Grid columns={3} stackable>

                                            <Grid.Row verticalAlign="top">

                                                <Grid.Column>

                                                    <Form.Field>
                                                        <label>Investigator Name</label>

                                                        <Form.Input
                                                            fluid
                                                            disabled
                                                            value={
                                                                this.state.receipt_model.getInvestigatorId()?.name || "N/A"
                                                            }
                                                        />
                                                    </Form.Field>

                                                </Grid.Column>

                                                <Grid.Column>

                                                    <Form.Field>
                                                        <label>Request Status</label>

                                                        <div style={{ marginTop: 6 }}>
                                                            <Label
                                                                color={
                                                                    this.state.receipt_model.getRequestStatus() === "Accepted"
                                                                        ? "green"
                                                                        : this.state.receipt_model.getRequestStatus() === "Rejected"
                                                                            ? "red"
                                                                            : "yellow"
                                                                }
                                                                size="large"
                                                            >
                                                                {this.state.receipt_model.getRequestStatus() || "N/A"}
                                                            </Label>
                                                        </div>

                                                    </Form.Field>

                                                </Grid.Column>

                                                <Grid.Column>

                                                    <Form.Field>
                                                        <label>Request Handled By</label>

                                                        <Form.Input
                                                            fluid
                                                            disabled
                                                            value={
                                                                this.state.receipt_model.getRequestActionTakenBy()?.name || "N/A"
                                                            }
                                                        />
                                                    </Form.Field>

                                                </Grid.Column>

                                            </Grid.Row>

                                            <Grid.Row>

                                                <Grid.Column>

                                                    <Form.Field>
                                                        <label>Address</label>

                                                        <Form.TextArea
                                                            disabled
                                                            style={{
                                                                minHeight: 110,
                                                                resize: "none",
                                                                width: "100%"
                                                            }}
                                                            value={
                                                                this.state.receipt_model.getRequestAddress() || "N/A"
                                                            }
                                                        />
                                                    </Form.Field>

                                                </Grid.Column>

                                                <Grid.Column>

                                                    <Form.Field>
                                                        <label>Applied Date</label>

                                                        <Form.Input
                                                            fluid
                                                            disabled
                                                            value={
                                                                this.state.receipt_model.getRequestDate()
                                                                    ? moment(
                                                                        this.state.receipt_model.getRequestDate()
                                                                    ).format("LLL")
                                                                    : "N/A"
                                                            }
                                                        />
                                                    </Form.Field>

                                                </Grid.Column>

                                                <Grid.Column>

                                                    <Form.Field>
                                                        <label>Coordinates</label>

                                                        <Form.Input
                                                            fluid
                                                            disabled
                                                            value={
                                                                this.state.receipt_model
                                                                    .getRequestCoordinates()
                                                                    ?.join(", ") || "N/A"
                                                            }
                                                        />
                                                    </Form.Field>

                                                </Grid.Column>

                                            </Grid.Row>

                                            <Grid.Row>

                                                <Grid.Column width={16}>

                                                    <Form.Field>
                                                        <label>Rejection Reason</label>

                                                        <Form.TextArea
                                                            disabled
                                                            style={{
                                                                minHeight: 90,
                                                                resize: "none"
                                                            }}
                                                            value={
                                                                this.state.receipt_model.getRequestRejectionReason() || "N/A"
                                                            }
                                                        />
                                                    </Form.Field>

                                                </Grid.Column>

                                            </Grid.Row>

                                        </Grid>
                                    </Segment>

                                    {this.state.receipt_model.getRequestStatus() !== "Rejected" && (
                                        <>
                                                    <Segment>

                                                        <Header size="small" color="green">
                                                            Receipt Information
                                                        </Header>

                                                        <Grid columns={3} stackable>

                                                            <Grid.Row>
                                                                <Grid.Column>

                                                                    <Form.Field>
                                                                        <label>Latest Receipt</label>

                                                                        {this.state.receipt_model.getLodgingReceipts()?.length ? (

                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    gap: 10,
                                                                                    marginTop: 8,
                                                                                    flexWrap: "wrap"
                                                                                }}
                                                                            >

                                                                                <div
                                                                                    style={{
                                                                                        padding: "10px 14px",
                                                                                        border: "1px solid #d4d4d5",
                                                                                        borderRadius: 4,
                                                                                        background: "#f9fafb",
                                                                                        minWidth: 250,
                                                                                        display: "flex",
                                                                                        alignItems: "center"
                                                                                    }}
                                                                                >

                                                                                    <FileLabel
                                                                                        title={
                                                                                            this.state.receipt_model
                                                                                                .getLodgingReceipts()
                                                                                            [
                                                                                                this.state.receipt_model
                                                                                                    .getLodgingReceipts()
                                                                                                    .length - 1
                                                                                            ]
                                                                                                .split("/")
                                                                                                .pop()
                                                                                        }
                                                                                        link={`${config.frontEndURL}/${this.state.receipt_model
                                                                                            .getLodgingReceipts()
                                                                                        [
                                                                                            this.state.receipt_model
                                                                                                .getLodgingReceipts()
                                                                                                .length - 1
                                                                                        ]}`}
                                                                                    />

                                                                                </div>
                                                                            </div>

                                                                        ) : (

                                                                            <Form.Input
                                                                                fluid
                                                                                disabled
                                                                                value="N/A"
                                                                            />

                                                                        )}
                                                                    </Form.Field>

                                                                </Grid.Column>
                                                               
                                                                <Grid.Column>

                                                                    <Form.Field>
                                                                        <label>Receipt Status</label>

                                                                        <Form.Input
                                                                            fluid
                                                                            disabled
                                                                            value={
                                                                                this.state.receipt_model.getLodgingReceiptsStatus() || "N/A"
                                                                            }
                                                                        />
                                                                    </Form.Field>

                                                                </Grid.Column>

                                                                <Grid.Column>

                                                                    <Form.Field>
                                                                        <label>Receipt Action Taken By</label>

                                                                        <Form.Input
                                                                            fluid
                                                                            disabled
                                                                            value={
                                                                                this.state.receipt_model.getReceiptActionTakenBy()?.name || "N/A"
                                                                            }
                                                                        />
                                                                    </Form.Field>

                                                                </Grid.Column>
                                                            </Grid.Row>
                                                            <Grid.Row>
                                                                <Grid.Column>
                                                                    <Button
                                                                    size="small"
                                                                    color="green"
                                                                    icon="check"
                                                                    content="Approve Receipt"
                                                                    disabled={
                                                                    this.state.receipt_model.getLodgingReceipts().length === 0 ||   
                                                                    this.state.receipt_model.getLodgingReceiptsStatus() === "Accepted" ||
                                                                    this.state.receipt_model.getLodgingReceiptsStatus() === "Rejected"
                                                                    }
                                                                    onClick={() => this.actionReceipt("Accepted")}
                                                                    /> 
                                                                    <Button
                                                                    size="small"
                                                                    color="red"
                                                                    icon="close"
                                                                    content="Reject Receipt"
                                                                    disabled={
                                                                    this.state.receipt_model.getLodgingReceipts().length === 0 ||   
                                                                    this.state.receipt_model.getLodgingReceiptsStatus() === "Accepted" ||
                                                                    this.state.receipt_model.getLodgingReceiptsStatus() === "Rejected"
                                                                    }
                                                                    onClick={() => this.actionReceipt("Rejected")}
                                                                    />                                
                                                                </Grid.Column>
                                                            </Grid.Row>

                                                        </Grid>

                                                    </Segment>

                                            <Segment>

                                                <Header size="small" color="orange">
                                                    Amount Information
                                                </Header>

                                                <Grid columns={3} stackable>

                                                    <Grid.Row>

                                                        <Grid.Column>

                                                            <Form.Field>
                                                                <label>Lodging Amount</label>

                                                                <Form.Input
                                                                    fluid
                                                                    value={
                                                                        this.state.lodging_amount
                                                                    }
                                                                    disabled={
                                                                        this.state.receipt_model.getLodgingReceipts().length === 0 ||
                                                                        this.state.receipt_model.getLodgingReceiptsStatus() !== "Accepted" ||
                                                                        this.state.receipt_model.getLodgingAmountStatus() === "Accepted"
                                                                        
                                                                    }
                                                                    onChange={(e, { value }) => {
                                                                        console.log(value);
                                                                        this.setState({
                                                                            lodging_amount: value
                                                                        })
                                                                        }
                                                                    }
                                                                />
                                                            </Form.Field>

                                                        </Grid.Column>

                                                        <Grid.Column>

                                                            <Form.Field>
                                                                <label>Amount Status</label>

                                                                <Form.Input
                                                                    fluid
                                                                    disabled
                                                                    value={
                                                                        this.state.receipt_model.getLodgingAmountStatus() || "N/A"
                                                                    }
                                                                />
                                                            </Form.Field>

                                                        </Grid.Column>

                                                        <Grid.Column>

                                                            <Form.Field>
                                                                <label>Amount Action Taken By</label>

                                                                <Form.Input
                                                                    fluid
                                                                    disabled
                                                                    value={
                                                                        this.state.receipt_model.getAmountActionTakenBy()?.name || "N/A"
                                                                    }
                                                                />
                                                            </Form.Field>

                                                        </Grid.Column>

                                                    </Grid.Row>

                                                    <Grid.Row>

                                                        <Grid.Column>

                                                            <Button
                                                                color="green"
                                                                disabled={
                                                                    !this.state.lodging_amount ||
                                                                    this.state.receipt_model.getLodgingAmountStatus() === "Accepted"
                                                                }
                                                                onClick={() => this.actionAmount()}
                                                            >
                                                                Approve Amount
                                                            </Button>

                                                        </Grid.Column>

                                                    </Grid.Row>

                                                </Grid>

                                            </Segment>
                                            

                                                    <Segment>

                                                        <Header size="small" color="violet">
                                                            Payment Information
                                                        </Header>

                                                        <Grid columns={3} stackable>

                                                            <Grid.Row>
                                                                <Grid.Column>

                                                                    <Form.Field>
                                                                        <label>Payment Date</label>

                                                                        <Form.Input
                                                                            fluid
                                                                            disabled
                                                                            value={
                                                                                this.state.receipt_model.getPaymentDate()
                                                                                    ? moment(
                                                                                        this.state.receipt_model.getPaymentDate()
                                                                                    ).format("LLL")
                                                                                    : "N/A"
                                                                            }
                                                                        />
                                                                    </Form.Field>

                                                                </Grid.Column>

                                                                <Grid.Column>

                                                                    <Form.Field>
                                                                        <label>UTR Number</label>

                                                                        <Form.Input
                                                                            fluid
                                                                            disabled
                                                                            value={
                                                                                this.state.receipt_model.getUtrNumber() || "N/A"
                                                                            }
                                                                        />
                                                                    </Form.Field>

                                                                </Grid.Column>
                                                                <Grid.Column>

                                                                    <Form.Field>
                                                                        <label>Payment Status</label>

                                                                        <Form.Input
                                                                            fluid
                                                                            disabled
                                                                            value={
                                                                                this.state.receipt_model.getPaymentStatus() || "N/A"
                                                                            }
                                                                        />
                                                                    </Form.Field>

                                                                </Grid.Column>
                                                            </Grid.Row>

                                                        </Grid>

                                                    </Segment>
                                        </>
                                    )}

                                </div>
                            )}
                        </Modal.Content>

                        <Modal.Actions>
                            <Button
                                onClick={() =>
                                    this.setState({
                                        receipt_modalOpen: false,
                                        receipt_model: null
                                    })
                                }
                            >
                                Close
                            </Button>
                        </Modal.Actions>
                    </Modal>                
                
                </Page>
            </FilterPageContext.Provider>
        )
    }
}

export default (props: any) => {
    return (
        <RequirePermission permission={permissions.Master.CRUD}>
            <LodgingExpensesPage {...props} />
        </RequirePermission>
    )
}
